var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2222 0.666992H1.7778C1.54206 0.666992 1.31596 0.760643 1.14927 0.927342C0.982566 1.09404 0.888916 1.32013 0.888916 1.55588V10.4448C0.888916 10.6805 0.982566 10.9066 1.14927 11.0733C1.31596 11.24 1.54206 11.3337 1.7778 11.3337H14.2222C14.458 11.3337 14.6841 11.24 14.8508 11.0733C15.0175 10.9066 15.1111 10.6805 15.1111 10.4448V1.55588C15.1111 1.32013 15.0175 1.09404 14.8508 0.927342C14.6841 0.760643 14.458 0.666992 14.2222 0.666992ZM13.5378 10.4448H2.51558L5.62669 7.22699L4.98669 6.60921L1.7778 9.92921V2.23144L7.30225 7.72921C7.46879 7.89477 7.69408 7.9877 7.92892 7.9877C8.16375 7.9877 8.38904 7.89477 8.55558 7.72921L14.2222 2.09366V9.87144L10.9511 6.60033L10.3245 7.22699L13.5378 10.4448ZM2.36003 1.55588H13.5022L7.92892 7.0981L2.36003 1.55588Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/EmailIcon.a0396823a5da2843ab699451ca195901.svg";
export { ForwardRef as ReactComponent };